import { IEvent } from "@Interfaces";
import {
    calculatePaymentInfoForSingleOffering,
    EVENT_TYPE,
    getBillingDataFromPaymentInfos,
    GST_STATUS,
    IPaymentInfoForSingleOffering,
} from "@Utils";
import { getUpsellListingsForEventId } from "../components/UpsellListings/utils/getUpsellListingsForEventId";
import { getSelectedUpsellOfferingsData } from "./getSelectedUpsellListingsData";
import { IInstalment } from "../components/PaymentPlan/IPaymentPlan";

/**
 * calculate billing data for (base offering + upsell offering selected)
 */
export const getBillingData = ({
    event,
    eventData,
    initialInstalment,
    selectedPaymentType,
    earlyBirdObj,
}: {
    event: IEvent.IStore;
    eventData: IPaymentInfoForSingleOffering.IEventDataNeeded;
    selectedPaymentType?: number;
    initialInstalment?: IInstalment;
    earlyBirdObj?: IEvent.IEarlyBird | null;
}) => {
    const {
        paymentInfo: {
            slots,
            quantity,
            numberOfCustomers,
            otherListings: selectedUpsellOfferingsQuantities, // quantities of listings selected from upsell
        },

        discount: { discountData },
    }: IEvent.IStore = event;

    const paymentInfoForMainOffering: IPaymentInfoForSingleOffering.IReturn =
        calculatePaymentInfoForSingleOffering({
            eventData,
            quantity,
            slots,
            numberOfCustomers,
            discountData,
            initialInstalment,
            selectedPaymentType,
            earlyBirdObj,
        });

    const upsellListings: Array<IEvent.IUpsellOffering> =
        getUpsellListingsForEventId({ eventId: eventData.uuid, event });

    const paymentInfos: IPaymentInfoForSingleOffering.IReturn[] = [
        paymentInfoForMainOffering,
        ...getSelectedUpsellOfferingsData({
            upsellListings,
            selectedUpsellOfferingsQuantities,
        }).map(l =>
            calculatePaymentInfoForSingleOffering({
                eventData: {
                    ...l,
                    gst_state: eventData?.gst_state || GST_STATUS.INAPPLICABLE,
                },
                numberOfCustomers,
                discountData,
                ...(l.type === EVENT_TYPE.MERCHANDISE && {
                    quantity:
                        selectedUpsellOfferingsQuantities?.[
                            l.additional_listing_uid
                        ]?.quantity ?? 1,
                }),
                // The billing display format state will be the same for all listings for a creator, so this can be reused
                billingDisplayFormatState:
                    paymentInfoForMainOffering.flags.billingDisplayFormatState,
                isUpsellListing: true,
            })
        ),
    ];

    const billingData = getBillingDataFromPaymentInfos(
        paymentInfos,
        numberOfCustomers
    );

    return { billingData, paymentInfos, paymentInfoForMainOffering };
};
